import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createStore,
  getAllStores,
  updateStore,
} from "../../actions/storeActions";
import defaultPic from "../../assets/img/dummy.jpeg";

const AdminEditStoreModal = ({ showEditModal, openEditModal, current }) => {
  const store = useSelector((state) => state.store);
  const city = useSelector((state) => state.city);
  const auth = useSelector((state) => state.auth);
  const categories = useSelector((state) => state.categories);
  // const [selectedValue, setSelectedValue] = useState([]);
  // const { loading } = store;
  const [selectedImage, setSelectedImage] = useState(defaultPic);

  const navigate = useNavigate();
  const [values, setValues] = useState({
    // categoryId: "",
    // storeId: Joi.string().custom(objectId),
    // userId: auth.user.id,
    name: "",
    _id: "",
    storeAddress: "",
    // storeStatus: "",
    // openAt: "",
    // closedAt: "",
    storeCommission: "",
    storeDescription: "",
    img: "",
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    // role: "",
    // createDate: "",
    email: "",
    password: "",
    status: "",
  });
  console.log(values, "values");

  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  //
  const dispatch = useDispatch();

  const currentCate = async () => {
    try {
      setValues({
        name: "",
        id: "",
        storeAddress: "",
        // storeStatus: "",
        // openAt: "",
        // closedAt: "",
        storeCommission: "",
        storeDescription: "",
        img: "",
        firstName: "",
        lastName: "",
        gender: "",
        phone: "",
        // role: "",
        // createDate: "",
        email: "",
        password: "",
        status: "",
        availabilityTime: [
          {
            day: 1,
            dayName: "Monday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 2,
            dayName: "Tuesday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 3,
            dayName: "Wednesday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 4,
            dayName: "Thursday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 5,
            dayName: "Friday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 6,
            dayName: "Saturday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
          {
            day: 7,
            dayName: "Sunday",
            openTime: "08:00",
            closeTime: "22:00",
            isOpened: true,
          },
        ],
      });
      setValues({
        id: current.id,
        name: current.name,
        status: current.status,
        storeAddress: current.storeAddress,
        // storeStatus: current.status,
        // openAt: current.status,
        // closedAt: current.status,
        storeCommission: current.storeCommission,
        storeDescription: current.storeDescription,
        // img: current.status,
        firstName: current.firstName,
        lastName: current.lastName,
        gender: current.gender,
        phone: current.phone,
        // role: current.status,
        // createDate: current.status,
        email: current.email,
        password: current.password,

        availabilityTime:
          current.availabilityTime && current.availabilityTime.length > 0
            ? current.availabilityTime
            : [
                {
                  day: 1,
                  dayName: "Monday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 2,
                  dayName: "Tuesday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 3,
                  dayName: "Wednesday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 4,
                  dayName: "Thursday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 5,
                  dayName: "Friday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 6,
                  dayName: "Saturday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
                {
                  day: 7,
                  dayName: "Sunday",
                  openTime: "08:00",
                  closeTime: "22:00",
                  isOpened: true,
                },
              ],
      });
      if (current.profilePic) {
        setSelectedImage(current.profilePic.fileUrl);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    currentCate();
  }, [current]);

  const storeData = {
    // categoryId: values.categoryId,
    // storeId: Joi.string().custom(objectId),
    _id: values.id,
    name: values.name,
    storeAddress: values.storeAddress,
    // storeStatus: values.storeStatus,
    // openAt: values.openAt,
    // closedAt: values.closedAt,
    storeCommission: values.storeCommission,
    storeDescription: values.storeDescription,
    // img: "",
    firstName: values.firstName,
    lastName: values.lastName,
    gender: values.gender,
    phone: values.phone,
    role: "admin",
    createDate: values.createDate,
    email: values.email,
    city: values.city,
    status: values.status ? values.status : true,
    password: values.password,
    availabilityTime: values.availabilityTime,
  };

  const [availabilityTime, setAvailabilityTime] = useState([]);
  // const handleTimeChange = (index, field, value) => {
  //   const updated = [...availabilityTime];
  //   updated[index][field] = value;
  //   setAvailabilityTime(updated);
  // };
  useEffect(() => {
    if (values?.availabilityTime?.length) {
      setAvailabilityTime([...values.availabilityTime]);
    }
  }, [values?.availabilityTime]);

  const handleTimeChange = (index, field, value) => {
    setAvailabilityTime((prev) => {
      const updated = [...prev];

      if (!updated[index]) {
        updated[index] = {}; // initialize if missing
      }

      updated[index][field] = value;
      return updated;
    });
  };

  console.log(storeData, "storeData");
  const handlePhone = (fieldName) => (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (numericValue.length > 0) {
      formattedValue = `(${numericValue.slice(0, 3)}`;
    }
    if (numericValue.length > 3) {
      formattedValue += `)${numericValue.slice(3, 6)}`;
    }
    if (numericValue.length > 6) {
      formattedValue += `-${numericValue.slice(6, 10)}`;
    }
    setValues({
      ...values,
      [fieldName]: formattedValue,
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("first");
    for (let key of Object.keys(storeData)) {
      if (storeData[key] === "") {
        delete storeData[key];
      }
    }
    dispatch(updateStore(storeData));
    setTimeout(() => {
      // if (userData.isDriver === true) {
      dispatch(getAllStores());
      // }
    }, 1000);
    openEditModal();
  };

  return (
    <>
      <div
        className={`modal fade ${showEditModal === true ? "show" : "hide"}`}
        id="addnewModal"
        tabIndex="-1"
        aria-labelledby="addnewModalLabel"
        // aria-hidden="true"
        onClick={(e) => {
          // Check if the click occurred outside the modal content
          if (e.target === e.currentTarget) {
            openEditModal(); // Call your close modal function
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addnewModalLabel">
                Manage Shops
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => openEditModal()}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="col-md-12">
                  <div className="text-center mb-5">
                    <label
                      className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                      // htmlFor="avatar_upload"
                    >
                      {/* <!-- Profile Image --> */}
                      <img
                        className="rounded border shadow-sm"
                        src={selectedImage}
                        alt="Profile Image"
                      />
                      {/* <!-- Hidden File Input --> */}
                      <input
                        type="file"
                        id="avatar_upload"
                        className="d-none"
                        accept=".jpg, .jpeg, .png, .bmp"
                      />
                      {/* <!-- Edit Icon --> */}
                      <span className="avatar-edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                        >
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </span>
                    </label>
                    {/* <!-- Image Upload Guidance --> */}
                    <p
                      className="fw-light text-info"
                      style={{ fontSize: "12px" }}
                    >
                      .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                      pixels
                    </p>
                  </div>
                </div>

                <fieldset>
                  <legend>OWNER DETAILS</legend>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="fName">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="fName"
                          placeholder="First Name"
                          value={values.firstName}
                          onChange={handleChange("firstName")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="lName">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="lName"
                          placeholder="Last Name"
                          value={values.lastName}
                          onChange={handleChange("lastName")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="Email"
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange("email")}
                          // required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange("password")}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="countrycode">Country code</label>
                        <input
                          type="text"
                          className="form-control"
                          id="countrycode"
                          placeholder="Country code"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="mobile">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          id="mobile"
                          placeholder="Mobile"
                          value={values.phone}
                          onChange={handlePhone("phone")}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label htmlFor="gender">Gender</label>
                        <select
                          className="form-select"
                          id="gender"
                          value={values.gender}
                          onChange={handleChange("gender")}
                        >
                          <option value="0" selected disabled>
                            Select Gender
                          </option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>STORES DETAILS</legend>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="storeName">Store Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="storeName"
                          placeholder="Store Name"
                          value={values.name}
                          onChange={handleChange("name")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="storeAddress">Store Address</label>
                        <textarea
                          className="form-control"
                          id="storeAddress"
                          rows="3"
                          placeholder="Store Address"
                          value={values.storeAddress}
                          onChange={handleChange("storeAddress")}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="Latitude">Latitude</label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="Latitude"
                          placeholder="Latitude"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="Longitude">Longitude</label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="Longitude"
                          placeholder="Longitude"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="storeCommission">Store Commision %</label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="storeCommission"
                          placeholder="Store Commision %"
                          value={values.storeCommission}
                          onChange={handleChange("storeCommission")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="storeDesc">Store Description</label>
                          <textarea
                            className="form-control"
                            // id="storeDesc"
                            rows="3"
                            placeholder="Store Description"
                            value={values.storeDescription}
                            onChange={handleChange("storeDescription")}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mt-4">
                      <label className="fw-bold">Opening Hours</label>
                      <table className="table table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Day</th>
                            <th>Open Time</th>
                            <th>Close Time</th>
                            <th>Open?</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values?.availabilityTime?.map((item, index) => (
                            <tr key={item?.dayName}>
                              <td>{item?.dayName}</td>
                              <td>
                                <input
                                  type="time"
                                  className="form-control"
                                  value={item?.openTime}
                                  onChange={(e) =>
                                    handleTimeChange(
                                      index,
                                      "openTime",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="time"
                                  className="form-control"
                                  value={item?.closeTime}
                                  onChange={(e) =>
                                    handleTimeChange(
                                      index,
                                      "closeTime",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={item?.isOpened}
                                  onChange={(e) =>
                                    handleTimeChange(
                                      index,
                                      "isOpened",
                                      e.target.checked
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="selectCity">Select City</label>
                        <select className="form-select" id="selectCity">
                          <option value="0" selected disabled>
                            {" "}
                            Please Select City
                          </option>
                          {city?.city?.map((x) => (
                            <option key={x?.id} value={x.id}>
                              {x?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="storeZipCode">Store ZipCode</label>
                        <input
                          type="text"
                          className="form-control"
                          id="storeZipCode"
                          placeholder="Store ZipCode"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => openEditModal()}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminEditStoreModal;
